/* v5.7 : recherche repliable sur mobile et galerie photo à faire glisser (fiche produit). */
(function(){"use strict";
  var b=document.body,t=document.getElementById("searchToggle");
  if(t)t.addEventListener("click",function(){var o=b.classList.toggle("search-open");t.setAttribute("aria-expanded",o);if(o){var i=document.getElementById("searchInput");i&&i.focus();}});
  Array.prototype.forEach.call(document.querySelectorAll("[data-mgal]"),function(g){
    var tr=g.querySelector(".m-gal__track"),c=g.querySelector("[data-mgal-count]"),n=tr.children.length;
    var upd=function(){if(c)c.textContent=(Math.round(tr.scrollLeft/(tr.clientWidth||1))+1)+" / "+n;};
    tr.addEventListener("scroll",upd,{passive:true});upd();
    var root=g.closest("[data-product-handle]");if(!root)return;
    var vs=[];try{vs=JSON.parse(root.querySelector("script[data-variants]").textContent)}catch(e){}
    /* Choix d'une variante : la galerie saute à sa photo (défilement direct, le défilement « smooth » est ignoré avec le scroll-snap). */
    root.addEventListener("change",function(e){
      if(!e.target.matches("[data-option]"))return;
      setTimeout(function(){
        var f=root.querySelector("[data-variant-id]"),id=f&&f.value,v=null;
        for(var k=0;k<vs.length;k++){if(String(vs[k].id)===String(id)){v=vs[k];break;}}
        if(!v||!v.featured_image)return;
        var s=tr.querySelector('[data-media="'+v.featured_image.id+'"]');
        if(s){tr.scrollLeft=s.offsetLeft;upd();}
      },60);
    });
  });
})();

/* v6.6 : bulle de l'assistante IA (appli Qstomy) déplaçable sur téléphone grâce à une petite poignée, et placée au-dessus de la barre d'onglets et du bouton « haut de page ». Position mémorisée sur l'appareil. */
(function(){"use strict";
  if(!window.matchMedia("(max-width:768px)").matches)return;
  var KEY="bisouQsPos",f=null,pos=null,drag=null;
  try{pos=JSON.parse(localStorage.getItem(KEY))}catch(e){}
  var css=document.createElement("style");
  css.textContent=".qstomy-iframe[data-size=idle][data-bisou-pos]{left:var(--bq-x)!important;right:auto!important;top:var(--bq-y)!important;bottom:auto!important}"+
    ".bq-grip{position:fixed;z-index:2147483647;width:26px;height:26px;margin:0;padding:0;border-radius:50%;border:2px solid #fff;background:#B0144F;color:#fff;display:none;align-items:center;justify-content:center;touch-action:none;box-shadow:0 4px 12px rgba(0,0,0,.25);cursor:grab}"+
    ".bq-grip svg{width:14px;height:14px}";
  document.head.appendChild(css);
  var grip=document.createElement("button");
  grip.type="button";grip.className="bq-grip";grip.setAttribute("aria-label","Déplacer l'assistante");
  grip.innerHTML='<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="9" cy="6" r="1.8"/><circle cx="15" cy="6" r="1.8"/><circle cx="9" cy="12" r="1.8"/><circle cx="15" cy="12" r="1.8"/><circle cx="9" cy="18" r="1.8"/><circle cx="15" cy="18" r="1.8"/></svg>';
  document.body.appendChild(grip);
  function tab(){var t=document.getElementById("tabbar");return t&&t.offsetHeight?t.offsetHeight:0}
  function size(){return{w:f.offsetWidth||84,h:f.offsetHeight||84}}
  function clamp(p){var s=size();return{x:Math.min(Math.max(0,p.x),innerWidth-s.w),y:Math.min(Math.max(70,p.y),innerHeight-s.h-tab()-4)}}
  function sync(){
    var idle=f&&f.getAttribute("data-size")==="idle"&&f.style.display!=="none"&&f.offsetWidth>0;
    grip.style.display=idle?"flex":"none";
    if(idle){var r=f.getBoundingClientRect();grip.style.left=(r.left+2)+"px";grip.style.top=(r.top+2)+"px"}
  }
  function place(p){pos=clamp(p);f.style.setProperty("--bq-x",pos.x+"px");f.style.setProperty("--bq-y",pos.y+"px");f.setAttribute("data-bisou-pos","");sync()}
  function init(fr){
    f=fr;var s=size();
    place(pos||{x:innerWidth-s.w,y:innerHeight-s.h-tab()-72});
    new MutationObserver(sync).observe(f,{attributes:true,attributeFilter:["data-size","style","class"]});
  }
  function end(){
    if(!drag)return;drag=null;grip.style.cursor="grab";
    var s=size();place({x:pos.x+s.w/2<innerWidth/2?0:innerWidth-s.w,y:pos.y});
    try{localStorage.setItem(KEY,JSON.stringify(pos))}catch(e){}
  }
  grip.addEventListener("pointerdown",function(e){if(!f)return;e.preventDefault();grip.setPointerCapture(e.pointerId);drag={dx:e.clientX-pos.x,dy:e.clientY-pos.y};grip.style.cursor="grabbing"});
  grip.addEventListener("pointermove",function(e){if(drag)place({x:e.clientX-drag.dx,y:e.clientY-drag.dy})});
  grip.addEventListener("pointerup",end);
  grip.addEventListener("pointercancel",end);
  addEventListener("resize",function(){if(f&&pos)place(pos)});
  var ex=document.querySelector(".qstomy-iframe");
  if(ex)init(ex);
  else new MutationObserver(function(m,o){var fr=document.querySelector(".qstomy-iframe");if(fr){o.disconnect();init(fr)}}).observe(document.body,{childList:true,subtree:true});
})();
